
export default {
  name: 'VsHeader',
  props: {
    sticky: {
      type: [Boolean, String, Number],
      default: null
    },
    fixed: {
      type: [Boolean, Object],
      default: false
    },
    contain: {
      type: [Boolean, Object],
      default: false
    },
    border: {
      type: [Boolean, String, Object],
      default: null
    },
    shadow: {
      type: [Boolean, Object],
      default: false
    },
    tag: {
      type: String,
      default: 'header'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      backgroundColor: 'white',
      $fixed: {
        position(value) {
          return value ? 'fixed' : null
        },
        pinTop(value) {
          return value ? true : null
        },
        width(value) {
          return value ? 'full' : null
        },
        zIndex(value) {
          return value ? 50 : null
        }
      },
      $border: {
        borderColor(value) {
          return value
        },
        borderBottomWidth(value) {
          return value ? true : null
        }
      },
      $shadow: {
        shadow(value) {
          return value ? 'default': null
        }
      }
    }
  }
}
